export const SELECT_COMPONENT = 'SELECT_COMPONENT';
export const CHANGE_PAGE_VIEW = 'CHANGE_PAGE_VIEW';

/* export const CHANGE_SEARCHFIELD = 'CHANGE_SEARCHFIELD';
export const REQUEST_ROBOTS_PENDING = 'REQUEST_ROBOTS_PENDING';
export const REQUEST_ROBOTS_SUCCESS = 'REQUEST_ROBOTS_SUCCESS';
export const REQUEST_ROBOTS_FAILED = 'REQUEST_ROBOTS_FAILED'; */